import { PropsWithChildren, ComponentType } from 'react';
import { AutoSizer } from 'react-virtualized-auto-sizer';

export default function responsive<T extends object>(Component: ComponentType<PropsWithChildren<T>>) {
  return function ComponentWithWidthProp(props: Omit<T, 'width'>) {
    return (
      // OA: Couldn't find a solution that keeps Typescript happy, hence the casting. It works, though,
      // and all the typings of components using this wrapper work as they should.
      <AutoSizer
        renderProp={({ width }) => {
          return <Component {...(props as T)} width={width ?? 0} />;
        }}
      />
    );
  };
}

export interface ResponsiveProps {
  width?: number;
}
